// extracted by mini-css-extract-plugin
export default {"rootMyFile":"myFile_rootMyFile__UopYa","tabs":"myFile_tabs__W9gru"};